import { Link } from 'react-router-dom';

export default function ArticleCTA() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="relative rounded-3xl overflow-hidden mb-10 group">
          <Link to="/article/superbuy-spreadsheet-complete-guide">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20inviting%20reading%20nook%20with%20open%20notebook%20featuring%20hand%20drawn%20shopping%20diagrams%20surrounded%20by%20carefully%20arranged%20fashion%20items%20and%20a%20steaming%20ceramic%20teacup%20sunlight%20filtering%20through%20sheer%20curtains%20editorial%20knowledge%20hub%20photography&width=1200&height=600&seq=article-cta-cover-v2&orientation=landscape"
              alt="The Complete Guide to Superbuy Spreadsheet"
              title="Superbuy Spreadsheet Complete Guide 2026"
              className="w-full aspect-[2/1] object-cover object-top group-hover:scale-[1.02] transition-transform duration-500"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-foreground-900/10 group-hover:bg-foreground-900/5 transition-colors duration-300"></div>
          </Link>
        </div>

        <h3 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-2">
          The Complete Guide to
        </h3>
        <h3 className="font-heading text-2xl md:text-4xl font-bold italic text-primary-500 leading-tight mb-2">
          Superbuy Spreadsheet
        </h3>
        <h3 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-8">
          for Smart Buyers
        </h3>

        <Link
          to="/article/superbuy-spreadsheet-complete-guide"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 text-base font-semibold hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          Read Full Guide
          <i className="ri-arrow-right-line"></i>
        </Link>

        <div className="mt-8 flex flex-wrap justify-center gap-2">
          <Link
            to="/article/superbuy-spreadsheet-shoes-buying-guide"
            className="inline-flex items-center px-4 py-2 rounded-full bg-background-50 border border-background-200/50 text-sm text-foreground-600 hover:text-foreground-900 hover:border-background-300/60 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Shoes Guide
          </Link>
          <Link
            to="/article/superbuy-spreadsheet-shipping-comparison"
            className="inline-flex items-center px-4 py-2 rounded-full bg-background-50 border border-background-200/50 text-sm text-foreground-600 hover:text-foreground-900 hover:border-background-300/60 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Shipping Guide
          </Link>
          <Link
            to="/article/superbuy-spreadsheet-beginners-handbook"
            className="inline-flex items-center px-4 py-2 rounded-full bg-background-50 border border-background-200/50 text-sm text-foreground-600 hover:text-foreground-900 hover:border-background-300/60 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Beginner Guide
          </Link>
          <Link
            to="/article/superbuy-spreadsheet-safety-scam-prevention"
            className="inline-flex items-center px-4 py-2 rounded-full bg-background-50 border border-background-200/50 text-sm text-foreground-600 hover:text-foreground-900 hover:border-background-300/60 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Safety Guide
          </Link>
        </div>
      </div>
    </section>
  );
}